import type {HeaderResponse} from '@github-ui/code-view-header/types'
import {isReactCodeViewSidebarEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {SidebarAboutResponse} from '@github-ui/code-view-sidebar/types'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'

export const sidebarAboutQuery = {
  queryName: 'sidebarAbout' as const,
  enabled: () => isReactCodeViewSidebarEnabled() || isFeatureEnabled('code_view_react_header'),
  queryDeps: ({params}: {params: Record<string, string | undefined>}) => ({
    pathname: `/${params.owner}/${params.repo}/_sidebar/about`,
  }),
  queryFn: async (queryKey: {queryDeps: {pathname: string}}) =>
    queryFnFetch<SidebarAboutResponse & HeaderResponse>(queryKey),
  type: QueryRouteQueryType.Blocking,
}
